
<template>
  <div>
    <v-card :outlined="$vuetify.theme.isDark">
      <v-card-title>Para onde deseja mover o departamento "{{ department.name }}"?</v-card-title>
      <v-card-subtitle>Selecione o caminho final do departamento a ser movido.</v-card-subtitle>
      <v-card-text class="pb-0">
        <v-form ref="moveForm">
          <select-department
            ref="selectDept"
            @deptSelected="setDeptToMove"
          ></select-department>

          <v-alert
            v-if="submiting_move && !local_dept"
            class="mt-3 mb-0"
            type="error"
          >
            Selecione um departamento
          </v-alert>

          <v-alert
            v-if="!can_select_department"
            class="mt-3 mb-0"
            type="error"
          >
            Não é possível mover o departamento para ele mesmo
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
            color="error"
            text
            @click="$emit('close')"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="secondary"
            text 
            @click="$emit('changeMoveKind', 'associations')"
          >
            Mover elementos
          </v-btn>
          <v-btn
            :disabled="!can_select_department"
            color="success"
            text
            @click="submitMove"
          >
            Mover
          </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "MoveDept",
  components: {
    selectDepartment: () => import('../../shared/selectDepartment.vue'),
  },
  props: {
    department: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      loading: false,
      loading_text: null,
      associations: null,
      submiting_move: false,
      local_dept: null,
      selected_dept: null
    }
  },
  methods: {
    setDeptToMove(dept) {
      this.local_dept = dept ? {...this.department} : null;
      this.selected_dept = {...dept};

      this.local_dept.ancestry = `${dept.ancestry}/${dept.id}`;
    },
    submitMove() {
      this.submiting_move = true;
      if (this.department.ancestry != this.local_dept) {
        this.loading = true;
        this.loading_text = "Movendo";
  
        this.updateDepartment(this.local_dept).then(() => {
          this.loading = false;
          this.loading_text = null;
          this.$emit("updated");
        })
      }
    },
    ...mapActions({
      updateDepartment: "Department/updateDepartment"
    })
  },
  computed: {
    can_select_department() {
      if (this.selected_dept) {
        if (this.selected_dept.id == this.department.id) {
          return false;
        }
      }

      return true;
    }
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>